import { render } from "./ServicesDirectory.vue?vue&type=template&id=776727c8"
import script from "./ServicesDirectory.vue?vue&type=script&lang=js"
export * from "./ServicesDirectory.vue?vue&type=script&lang=js"

import "./ServicesDirectory.vue?vue&type=style&index=0&id=776727c8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__